import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { endRideById, getRideDetailsById } from '../../../redux_store/rides/ride_thunk';
import { useDispatch, useSelector } from 'react-redux'
import LoadingModal from '../../templates/modals/LoadingModal';
import { LOADING, SUCCESS, FAIL } from '../../../redux_store/actionTypes';
import { convertFromPesewasToCedis, displayFile, getUserStars } from '../../../utils';
import toast from '../../templates/ToastMessage'
import moment from 'moment';

const ViewTripsDetails = () => {
  const { rides, status, message } = useSelector((state) => state.ride);
  const dispatch = useDispatch();
  const [ride, setRide] = useState({customer: {}, driver: {}});
  const driverPicRef = useRef(null);
  const customerPicRef = useRef(null);
  const params = useParams();

  useEffect(()=>{
    if(!Array.isArray(rides)){
      displayFile(rides.customer.profile_pic, customerPicRef.current);
      if(rides.driver_id){
        displayFile(rides.driver.profile_pic, driverPicRef.current);
      }
      setRide(rides);
    }
  }, [rides]);
  
  useEffect(() => {
    if (status === FAIL) {
      toast({ message, status });
    } else if (status === SUCCESS) {
      toast({ message, status });
      dispatch(getRideDetailsById(params.id));
    }
    // eslint-disable-next-line
  }, [status]);



  useEffect(() => {
    if (params.id) {
      dispatch(getRideDetailsById(params.id));
    }
    // eslint-disable-next-line
  }, [params.id]);

  return (
    <div className="grid grid-cols-6 bg-white gap-10 p-5 rounded-md shadow-md">
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      <div className='col-span-2 space-y-4'>
        <p className=' text-gray-600 text-sm font-semibold'>Driver Profile Picture</p>
        <div ref={driverPicRef} className='border border-blue-300 h-1/3 rounded-lg shadow-md'></div>
        <p className=' text-gray-600 text-sm font-semibold'>Customer Profile Picture</p>
        <div ref={customerPicRef} className='border border-blue-300 h-1/3 rounded-lg shadow-md'></div>
      </div>
      <div className="grid grid-cols-2 col-span-4">
        <div className="px-4 py-2 border mb-2 col-span-6 border-blue-300 sm:px-6">
          <h3 className="text-md leading-6 font-semibold text-blue-600">
            Actions
          </h3>
        </div>
        <div className='flex col-span-6 space-x-5 mb-5'>
          {(ride.status !== 'CANCELLED' && ride.status !== 'COMPLETED' && ride.status !== 'RATED') ?
            <button
              type='button'
              onClick={() => {
                dispatch(endRideById(ride.id))
              }}
              className='text-gray-100 text-xs py-2 px-4 rounded-md font-medium bg-red-700 border'>
              End Trip
            </button> : <p className='text-sm my-auto col-span-2 leading-5 font-medium text-gray-500'>No action can be performed</p>
          }
        </div>
        <div className="overflow-hidden sm:rounded-lg col-span-4">
          <div className="px-4 py-2 border border-blue-300 sm:px-6">
            <h3 className="text-md leading-6 font-semibold text-blue-600">
              Driver Info
            </h3>
          </div>
          {ride.driver_id ?
            <div>
              <dl>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Surname
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {ride.driver.surname}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Other names
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {ride.driver.other_names}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Rating
                  </dt>
                  <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {getUserStars(ride.driver.ratings)}
                  </dt>
                </div>
                <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Phone Number
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {ride.driver.phone_number}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Vehicle Name
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {ride.driver.vehicle_name || 'N/A'}
                  </dt>
                </div>
                <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    Vehicle Number Plate
                  </dt>
                  <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                    {ride.driver.vehicle_number_plate || 'N/A'}
                  </dt>
                </div>
              </dl>
            </div>
            : <p className=' text-gray-600 text-sm'>No Driver assigned yet</p>}

          <div className="px-4 py-2 mt-10 border border-blue-300 sm:px-6">
            <h3 className="text-md leading-6 font-semibold text-blue-600">
              Customer Info
            </h3>
          </div>
          <div>
            <dl>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Surname
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.customer.surname}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Other names
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.customer.other_names}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Rating
                </dt>
                <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {getUserStars(ride.customer.ratings)}
                </dt>
              </div>
              <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Phone Number
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.customer.phone_number}
                </dt>
              </div>
            </dl>
          </div>

          <div className="px-4 py-2 mt-10 border border-blue-300 sm:px-6">
            <h3 className="text-md leading-6 font-semibold text-blue-600">
              Trip Info
            </h3>
          </div>
          <div>
            <dl>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Status
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                {ride.status === 'PENDING' ? 
                    <p className='bg-yellow-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100 animate-bounce'>pending</p>: 
                  ride.status === 'TO PICKUP' ?  
                    <p className='bg-slate-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>to pickup location</p>:
                  ride.status === 'AT PICKUP' ?  
                    <p className='bg-slate-800 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>at pickup location</p>:
                  ride.status === 'TO DESTINATION' ?  
                    <p className=' bg-blue-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>to destination</p>:
                  ride.status === 'AT DESTINATION' ?  
                    <p className='bg-zinc-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>at destination</p>:
                  ride.status === 'COMPLETED' ?  
                    <p className='bg-green-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>completed</p>:
                  ride.status === 'CANCELLED' ?  
                    <p className='bg-red-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>cancelled</p>:
                  ride.status === 'RATED' ?  
                    <p className=' bg-orange-500 inline-block text-xs rounded-lg py-1 px-2 text-gray-100'>rated</p>:<p>Unknown</p>
                  }
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Origin
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.origin_description}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Destination
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.destination_description}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Customer Trip Rating
                </dt>
                <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {/* {getUserStars(ride.rating.rate)} */}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Driver Trip Rating
                </dt>
                <dt className="text-sm flex my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {/* {getUserStars(ride.rating.rate)} */}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Payment Method
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.payment_method}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Time Requested
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {moment(ride.createdAt).format('LLLL')}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Time Started
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.trip_start_time ? moment(ride.trip_start_time).format('LLLL'): 'N/A'}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Time Ended
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.trip_end_time ? moment(ride.trip_end_time).format('LLLL'): 'N/A'}
                </dt>
              </div>
              <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Actual Total Cost
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.actual_total_cost ? `GHC ${convertFromPesewasToCedis(ride.actual_total_cost).toFixed(2)}`: 'N/A'}
                </dt>
              </div>
              <div className="bg-white sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Discount
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.discounted_price ? `GHC ${convertFromPesewasToCedis(ride.discounted_price).toFixed(2)} (${ride.promo_code})`: 'No discount'}
                </dt>
              </div>
              <div className="sm:grid my-5 sm:grid-cols-4 sm:gap-4 sm:px-6">
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  Final Cost
                </dt>
                <dt className="text-sm my-auto col-span-2 leading-5 font-medium text-gray-500">
                  {ride.final_total_cost ? `GHC ${convertFromPesewasToCedis(ride.final_total_cost).toFixed(2)}`: 'N/A'}
                </dt>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewTripsDetails